import React from "react";

import { Divider, Flex } from "@olist/design-system";

import { DiscussionContainer } from "./styles";
import { Comment } from "../comment";
import { formatDateTime } from "helpers/dateUtils";
import { convertNewlinesToHtml } from "pages/ticket/constants";
import { ITicketInteractionMessageSegments } from "types/support-tickets";

const renderSegmentsAsHtml = (
  segments: ITicketInteractionMessageSegments[]
) => {
  let htmlString = "";

  const richTextSegments = segments.length > 1 ? segments.slice(1) : segments;

  richTextSegments.forEach((segment) => {
    switch (segment.type) {
      case "Text":
        htmlString += segment.text;
        break;
      case "MarkupBegin":
        if (segment.htmlTag === "a") {
          htmlString += `<${segment.htmlTag} href="${segment.url || ""}">`;
          break;
        }
        htmlString += `<${segment.htmlTag}>`;
        break;
      case "MarkupEnd":
        htmlString += `</${segment.htmlTag}>`;
        break;
      case "InlineImage":
        htmlString += `<img src="${segment.url || ""}" alt="${
          segment.altText || ""
        }" style="max-width: 100%;" />`;
        break;
      case "Hyperlink":
        htmlString += `<a href="${segment.url || ""}">${segment.text}</a>`;
        break;
      default:
        htmlString += segment.text;
        break;
    }
  });

  return htmlString;
};

export function Discussion({ contact_email, discussion }: any) {
  return (
    <DiscussionContainer>
      {discussion.map((comment: any, index: number, array: any) => {
        const formattedDate = formatDateTime(comment.date);
        const commentHtml = renderSegmentsAsHtml(comment.body);

        const lastComment =
          array.length - 1 === index ? "discussion-last-comment" : false;

        return (
          <Flex flexDirection="column" key={comment.id} gap="stack.medium">
            <Comment
              type={comment.sent_by as "user" | "support"}
              text={
                <span
                  dangerouslySetInnerHTML={{
                    __html: convertNewlinesToHtml(commentHtml),
                  }}
                />
              }
              date={formattedDate}
              id={lastComment}
              contact_email={contact_email}
            />
            {index !== array.length - 1 ? <Divider /> : <></>}
          </Flex>
        );
      })}
    </DiscussionContainer>
  );
}
